import React, { useState, useEffect } from 'react';
import {
  Smartphone, Wifi, Clock, Zap, Settings, History, Send, Phone, BellOff,
  CheckCircle2, AlertTriangle, BarChart3, Calendar, ChevronRight, Eye,
  Database, Filter, Inbox, Play, Pause, Bell, RefreshCw, MoreVertical,
  ArrowRight, Users, FileText, AlertCircle
} from 'lucide-react';

const fmt = (v) => `R$ ${v.toFixed(2).replace('.', ',')}`;

// Dados mockados realistas (baseados no banco real)
const MOCK = {
  whatsapp: { numero: '+55 98 8922-3764', nome: 'Nb Locacoes', conectado: true, instancia: 'Atendimento' },
  proximaExec: '04h 23min',
  ativo: true,
  metricas: { elegiveis: 112, sem_telefone: 353, enviadas_hoje: 0, total_hoje: 112 },
  fila: [
    { nome: 'GUSTAVO HENRIQUE DA SILVA MACIEL', faixa: 'atraso_critico', dias: 45, valor: 250, veiculo: 'YAMAHA FACTOR 150', placa: 'PSP-1I90' },
    { nome: 'DANIEL DA SILVA SOUSA',            faixa: 'atraso_leve',    dias: 3,  valor: 180, veiculo: 'HONDA CB 300', placa: 'ABC-1234' },
    { nome: 'MARIA SANTOS OLIVEIRA',            faixa: 'vence_hoje',     dias: 0,  valor: 320, veiculo: 'HONDA FAN 160', placa: 'DEF-5678' },
    { nome: 'PEDRO ALVES CARVALHO',             faixa: 'atraso_critico', dias: 12, valor: 280, veiculo: 'YAMAHA FACTOR', placa: 'GHI-9012' },
    { nome: 'F. IMM BRASIL LTD',                faixa: 'atraso_leve',    dias: 4,  valor: 420, veiculo: 'HONDA XRE 300', placa: 'JKL-3456' },
    { nome: 'OSVALDIR DE LIMA GOMES',           faixa: 'atraso_critico', dias: 37, valor: 150, veiculo: 'HONDA BIZ 125', placa: 'NOP-7890' },
  ],
};

const FAIXA_COLOR = {
  vence_hoje:      { bg: 'bg-blue-50',   border: 'border-blue-200',   text: 'text-blue-700',   label: 'Vence hoje' },
  atraso_leve:     { bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-800', label: 'Atraso leve' },
  atraso_critico:  { bg: 'bg-red-50',    border: 'border-red-200',    text: 'text-red-700',    label: 'Atraso crítico' },
};


// ════════════════════════════════════════════════════════════════════════════
// OPÇÃO 1: COMMAND CENTER
// ════════════════════════════════════════════════════════════════════════════
function Option1CommandCenter() {
  const [aba, setAba] = useState('regras');
  return (
    <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200">
      <h2 className="text-lg font-bold text-slate-900 mb-4 tracking-tight">
        Opção 1: Command Center <span className="text-xs font-normal text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded ml-2">Recomendada</span>
      </h2>

      {/* HERO STATUS */}
      <div className="bg-white rounded-xl border-2 border-slate-900 p-5 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
              <Smartphone className="w-6 h-6 text-emerald-700" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="font-bold text-slate-900 truncate">{MOCK.whatsapp.nome}</p>
                <span className="bg-emerald-100 text-emerald-800 text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide">● Online</span>
              </div>
              <p className="text-xs text-slate-500 font-mono">{MOCK.whatsapp.numero}</p>
            </div>
            <button className={`w-14 h-7 rounded-full relative transition-colors ${MOCK.ativo ? 'bg-emerald-600' : 'bg-slate-300'}`}>
              <span className={`absolute top-0.5 w-6 h-6 bg-white rounded-full shadow transition-all ${MOCK.ativo ? 'left-7' : 'left-0.5'}`} />
            </button>
          </div>
          <div className="border-l border-slate-200 pl-4 flex items-center gap-3">
            <Clock className="w-5 h-5 text-slate-400" />
            <div className="flex-1">
              <p className="text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-500">Próxima execução</p>
              <p className="text-2xl font-bold text-slate-900 tabular-nums">{MOCK.proximaExec}</p>
            </div>
            <button className="bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-wide px-3 py-2 rounded-lg flex items-center gap-1.5">
              <Zap className="w-3.5 h-3.5" /> Disparar
            </button>
          </div>
        </div>
      </div>

      {/* BENTO METRICS */}
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="bg-white rounded-xl border border-emerald-200 p-4">
          <CheckCircle2 className="w-5 h-5 text-emerald-600 mb-2" />
          <p className="text-3xl font-bold text-slate-900 tabular-nums">{MOCK.metricas.elegiveis}</p>
          <p className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 mt-1">Elegíveis agora</p>
        </div>
        <div className="bg-white rounded-xl border border-amber-200 p-4">
          <AlertTriangle className="w-5 h-5 text-amber-600 mb-2" />
          <p className="text-3xl font-bold text-slate-900 tabular-nums">{MOCK.metricas.sem_telefone}</p>
          <p className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 mt-1">Sem telefone</p>
          <button className="text-[10px] mt-2 font-semibold text-amber-700 hover:underline">Cadastrar →</button>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <Send className="w-5 h-5 text-slate-700 mb-2" />
          <p className="text-3xl font-bold text-slate-900 tabular-nums">{MOCK.metricas.enviadas_hoje}<span className="text-sm text-slate-400 font-normal">/{MOCK.metricas.total_hoje}</span></p>
          <p className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 mt-1">Enviadas hoje</p>
        </div>
      </div>

      {/* TABS */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="flex border-b border-slate-200">
          {[
            { id: 'regras',     label: 'Regras',    icon: Settings },
            { id: 'horarios',   label: 'Horários',  icon: Clock },
            { id: 'historico',  label: 'Histórico', icon: History },
            { id: 'teste',      label: 'Teste',     icon: Send },
          ].map((t) => (
            <button key={t.id} onClick={() => setAba(t.id)}
              className={`flex-1 px-4 py-3 text-xs font-semibold uppercase tracking-wide flex items-center justify-center gap-1.5 transition-colors ${
                aba === t.id ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-50'
              }`}>
              <t.icon className="w-3.5 h-3.5" />{t.label}
            </button>
          ))}
        </div>
        <div className="p-5 space-y-3">
          {aba === 'regras' && (
            <>
              <div className="flex items-center justify-between p-3 rounded-lg border border-blue-200 bg-blue-50/40">
                <div>
                  <p className="font-semibold text-sm text-slate-900">Vencimento hoje</p>
                  <p className="text-xs text-slate-500">0 dias · Template: Vencimento hoje · Reenviar: 1d</p>
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">● Ativo</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg border border-yellow-200 bg-yellow-50/40">
                <div>
                  <p className="font-semibold text-sm text-slate-900">Atraso leve</p>
                  <p className="text-xs text-slate-500">1-4 dias · Template: Atraso leve · Reenviar: 3d</p>
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">● Ativo</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg border border-red-200 bg-red-50/40">
                <div>
                  <p className="font-semibold text-sm text-slate-900">Atraso crítico</p>
                  <p className="text-xs text-slate-500">5+ dias · Template: Aviso bloqueio · Reenviar: 7d</p>
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">● Ativo</span>
              </div>
            </>
          )}
          {aba === 'horarios' && (
            <div className="flex flex-wrap gap-2">
              <span className="bg-slate-900 text-white text-xs font-bold px-3 py-2 rounded-lg">09:00</span>
              <span className="bg-slate-100 text-slate-700 text-xs font-bold px-3 py-2 rounded-lg border border-dashed border-slate-300">+ Adicionar</span>
            </div>
          )}
          {aba === 'historico' && <p className="text-xs text-slate-500 italic">Últimas execuções aparecem aqui...</p>}
          {aba === 'teste' && <p className="text-xs text-slate-500 italic">Campo de teste aqui...</p>}
        </div>
      </div>
    </div>
  );
}


// ════════════════════════════════════════════════════════════════════════════
// OPÇÃO 2: PIPELINE VISUAL
// ════════════════════════════════════════════════════════════════════════════
function Option2Pipeline() {
  const [step, setStep] = useState(2);
  const steps = [
    { id: 0, icon: Database,  label: 'Dados',   stat: '465 vencidas' },
    { id: 1, icon: Filter,    label: 'Regras',  stat: '112 válidas' },
    { id: 2, icon: Inbox,     label: 'Fila',    stat: '112 prontas' },
    { id: 3, icon: Send,      label: 'Disparo', stat: 'em 04h 23m' },
  ];
  return (
    <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200">
      <h2 className="text-lg font-bold text-slate-900 mb-4 tracking-tight">Opção 2: Pipeline Visual</h2>

      {/* HERO STATUS COMPACT */}
      <div className="bg-white rounded-xl border border-slate-200 p-4 mb-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
          <p className="text-sm font-semibold text-slate-900">{MOCK.whatsapp.nome}</p>
          <span className="text-xs text-slate-500 font-mono">{MOCK.whatsapp.numero}</span>
        </div>
        <button className="w-12 h-6 rounded-full bg-emerald-600 relative">
          <span className="absolute top-0.5 left-6 w-5 h-5 bg-white rounded-full shadow" />
        </button>
      </div>

      {/* PIPELINE */}
      <div className="bg-white rounded-xl border border-slate-200 p-6 mb-4">
        <div className="flex items-center justify-between gap-2">
          {steps.map((s, i) => (
            <React.Fragment key={s.id}>
              <button onClick={() => setStep(s.id)} className="flex flex-col items-center gap-2 group">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-all ${
                  step === s.id    ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-200 scale-110'
                  : step > s.id    ? 'bg-emerald-100 text-emerald-700'
                  :                  'bg-slate-100 text-slate-400'
                }`}>
                  <s.icon className="w-6 h-6" />
                </div>
                <div className="text-center">
                  <p className={`text-xs font-bold ${step === s.id ? 'text-slate-900' : 'text-slate-500'}`}>{s.label}</p>
                  <p className="text-[10px] text-slate-500 tabular-nums">{s.stat}</p>
                </div>
              </button>
              {i < steps.length - 1 && (
                <div className={`flex-1 h-0.5 mx-1 transition-colors ${step > i ? 'bg-emerald-500' : 'bg-slate-200'}`} />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* DETALHES DO STEP */}
        <div className="mt-6 p-4 rounded-lg bg-slate-50 border border-slate-200 min-h-[120px]">
          {step === 0 && (
            <>
              <p className="font-bold text-sm text-slate-900 mb-2">📊 Dados — 465 faturas vencidas</p>
              <p className="text-xs text-slate-500">112 com telefone · 353 sem telefone <button className="ml-2 font-semibold text-amber-700 hover:underline">Cadastrar →</button></p>
            </>
          )}
          {step === 1 && (
            <>
              <p className="font-bold text-sm text-slate-900 mb-2">⚙️ Regras — 112 passaram nos filtros</p>
              <p className="text-xs text-slate-500">17 vencem hoje · 20 atraso leve · 75 atraso crítico</p>
            </>
          )}
          {step === 2 && (
            <>
              <p className="font-bold text-sm text-slate-900 mb-2">📋 Fila — 112 mensagens prontas</p>
              <p className="text-xs text-slate-500">Total a enviar: R$ 44.089,36</p>
              <button className="mt-3 text-xs bg-slate-900 text-white px-3 py-1.5 rounded-lg font-semibold">Ver todas →</button>
            </>
          )}
          {step === 3 && (
            <>
              <p className="font-bold text-sm text-slate-900 mb-2">🚀 Disparo — em 04h 23min</p>
              <p className="text-xs text-slate-500">Próximo horário agendado: 09:00 BRT</p>
              <button className="mt-3 text-xs bg-emerald-600 text-white px-3 py-1.5 rounded-lg font-semibold flex items-center gap-1.5">
                <Zap className="w-3 h-3" /> Disparar agora
              </button>
            </>
          )}
        </div>
      </div>

      <p className="text-xs text-slate-500 italic text-center">
        Configurações abrem em painel lateral (clique no engrenagem de cada etapa)
      </p>
    </div>
  );
}


// ════════════════════════════════════════════════════════════════════════════
// OPÇÃO 3: INBOX / FILA
// ════════════════════════════════════════════════════════════════════════════
function Option3Inbox() {
  const [selecionados, setSelecionados] = useState(new Set([0, 1, 2]));
  const toggle = (i) => setSelecionados((s) => {
    const n = new Set(s); n.has(i) ? n.delete(i) : n.add(i); return n;
  });
  return (
    <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200">
      <h2 className="text-lg font-bold text-slate-900 mb-4 tracking-tight">Opção 3: Inbox / Fila</h2>

      {/* HEADER COMPACTO */}
      <div className="bg-white rounded-xl border border-slate-200 p-3 mb-3 flex items-center justify-between text-xs">
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />Conectado: <span className="font-mono font-semibold">{MOCK.whatsapp.numero}</span></span>
        </div>
        <span className="text-slate-500">Próximo disparo: <span className="font-bold text-slate-900">{MOCK.proximaExec}</span> · <button className="text-blue-600 hover:underline font-semibold">⚙️ Configurações</button></span>
      </div>

      {/* INBOX */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {/* TOOLBAR */}
        <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <input type="checkbox" checked={selecionados.size === MOCK.fila.length} readOnly className="rounded" />
            <p className="text-sm font-semibold text-slate-900">
              {selecionados.size > 0 ? `${selecionados.size} seleccionada${selecionados.size>1?'s':''}` : `${MOCK.fila.length} mensagens pendentes`}
            </p>
          </div>
          <div className="flex items-center gap-2">
            {selecionados.size > 0 ? (
              <>
                <button className="text-xs px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50">Excluir da fila</button>
                <button className="text-xs px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-semibold flex items-center gap-1.5">
                  <Send className="w-3 h-3" /> Enviar {selecionados.size} agora
                </button>
              </>
            ) : (
              <button className="text-xs px-3 py-1.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-semibold flex items-center gap-1.5">
                <Zap className="w-3 h-3" /> Disparar todas
              </button>
            )}
          </div>
        </div>

        {/* LISTA */}
        <div className="divide-y divide-slate-100">
          {MOCK.fila.map((m, i) => {
            const c = FAIXA_COLOR[m.faixa];
            const sel = selecionados.has(i);
            return (
              <div key={i} className={`flex items-center gap-3 px-4 py-3 hover:bg-slate-50 ${sel ? 'bg-blue-50/40' : ''}`}>
                <input type="checkbox" checked={sel} onChange={() => toggle(i)} className="rounded" />
                <span className={`w-1.5 h-8 rounded-full ${c.border.replace('border-','bg-').replace('-200','-500')}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-semibold text-slate-900 truncate">{m.nome}</p>
                    <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${c.bg} ${c.text} border ${c.border}`}>{c.label}</span>
                  </div>
                  <p className="text-xs text-slate-500 truncate">{m.veiculo} · {m.placa} · {fmt(m.valor)} · {m.dias === 0 ? 'vence hoje' : `${m.dias}d atraso`}</p>
                </div>
                <button className="text-xs text-slate-500 hover:text-slate-900 px-2"><Eye className="w-4 h-4" /></button>
              </div>
            );
          })}
        </div>
        <div className="px-4 py-2 border-t border-slate-100 text-center">
          <button className="text-xs text-slate-500 hover:text-slate-900">Mostrar mais 106 mensagens →</button>
        </div>
      </div>

      <p className="text-xs text-slate-500 italic text-center mt-3">
        Configurações de regras/horários ficam em página separada
      </p>
    </div>
  );
}


// ════════════════════════════════════════════════════════════════════════════
// PÁGINA PRINCIPAL — mostra as 3 opções lado a lado
// ════════════════════════════════════════════════════════════════════════════
export default function MockupsAutomacao() {
  const [opcao, setOpcao] = useState('all');
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Mockups — Painel de Automação</h1>
          <p className="text-sm text-slate-600 mt-1">3 propostas visuais para você comparar antes de implementar.</p>
        </div>

        <div className="flex items-center gap-2 mb-6 overflow-x-auto">
          {[
            { id: 'all', label: 'Ver todas' },
            { id: '1',   label: 'Opção 1: Command Center' },
            { id: '2',   label: 'Opção 2: Pipeline Visual' },
            { id: '3',   label: 'Opção 3: Inbox / Fila' },
          ].map((b) => (
            <button key={b.id} onClick={() => setOpcao(b.id)}
              className={`text-xs font-semibold px-3 py-2 rounded-lg whitespace-nowrap transition-colors ${
                opcao === b.id ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}>
              {b.label}
            </button>
          ))}
        </div>

        <div className="space-y-8">
          {(opcao === 'all' || opcao === '1') && <Option1CommandCenter />}
          {(opcao === 'all' || opcao === '2') && <Option2Pipeline />}
          {(opcao === 'all' || opcao === '3') && <Option3Inbox />}
        </div>

        <div className="mt-10 p-5 bg-slate-50 border border-slate-200 rounded-xl">
          <p className="text-sm text-slate-700">
            <strong>Próximo passo:</strong> me diga qual opção (1, 2 ou 3) prefere, e implemento a versão real
            no painel `/notificacoes` substituindo o atual.
          </p>
        </div>
      </div>
    </div>
  );
}
